import CreateCriteria from "./CreateCriteria"

export default CreateCriteria;